import { Block, JNode, Section } from '../../types';
import { jNodesToBlocks } from './jnode-to-blocks';

export function jDocToSections(jDoc: JNode): Section[] {
  return jDoc.content.map((jNode: JNode) => {
    return {
      id: jNode.attributes.id,
      name: jNode.attributes.name || null,
      tainted: true,
      blocks: jNodesToBlocks(jNode.content),
    };
  });
}
